var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09838 0.581245C2.959 -0.279374 4.38234 -0.178218 5.1126 0.79546L6.32478 2.4117C6.92196 3.20794 6.84277 4.32213 6.13899 5.02591L5.24528 5.91962C5.33189 6.14506 5.61701 6.63979 6.48528 7.50805C7.35355 8.37632 7.84827 8.66144 8.07371 8.74805L8.96742 7.85434C9.6712 7.15056 10.7854 7.07137 11.5816 7.66856L13.1979 8.88074C14.1716 9.611 14.2727 11.0343 13.4121 11.895C13.1323 12.1748 13.0849 12.2221 12.618 12.689C12.1421 13.1649 11.1317 13.6097 10.1087 13.6542C8.50782 13.7238 6.3333 13.0129 3.65685 10.3365C0.980404 7.66003 0.269563 5.48552 0.339166 3.88464C0.377885 2.9941 0.661014 2.01601 1.30804 1.37904C1.77124 0.908391 1.83147 0.848153 2.09838 0.581245ZM1.67124 3.94255C1.62299 5.05225 2.09066 6.88467 4.59966 9.39367C7.10866 11.9027 8.94109 12.3703 10.0508 12.3221C11.0867 12.2771 11.6424 11.7765 11.6752 11.7462L12.4693 10.9521C12.7562 10.6653 12.7224 10.1908 12.3979 9.94741L10.7816 8.73522C10.5162 8.53616 10.1448 8.56256 9.91023 8.79715C9.55677 9.15061 9.31549 9.39546 8.8432 9.86597C7.86211 10.8433 6.18273 9.09112 5.54247 8.45086C4.95408 7.86248 3.16098 6.12977 4.12641 5.15289C4.12832 5.15097 4.38835 4.89093 5.19618 4.08311C5.43078 3.84851 5.45717 3.47711 5.25811 3.2117L4.04593 1.59546C3.80251 1.2709 3.32806 1.23718 3.04119 1.52405C2.77716 1.78809 2.47834 2.0869 2.24792 2.31892C1.77367 2.79644 1.69662 3.35882 1.67124 3.94255Z",
    fill: "#777E91"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8f522200dd622f4aed707e1d7fcca1f6.svg";
export { ForwardRef as ReactComponent };